import { render, staticRenderFns } from "./Top10KundenBereichFuenftUmsatz.vue?vue&type=template&id=433ea766&"
import script from "./Top10KundenBereichFuenftUmsatz.vue?vue&type=script&lang=ts&"
export * from "./Top10KundenBereichFuenftUmsatz.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports